/**
 * Публичный API webview-интеграции клиентского модуля.
 *
 * Системные действия/события моста доступны напрямую из `./vendor/web`
 * (`bridge`, `SYSTEM_ACTIONS`, `SYSTEM_EVENTS`).
 */
export { closeWebView } from './base-actions';
export {
  notifyOrderCancelled,
  notifyOrderSubmitted,
  onOrderStatusChanged,
  useOrderStatusChanged
} from './contract';
export type {
  LeasingAction as AutoCreditAction,
  LeasingEvent as AutoCreditEvent,
  OrderStatusChangedPayload
} from './contract';
export { isInWebView } from './env';
export { setupBridge, WEBVIEW_ROOT_CLASS } from './setup';
export { default as WebViewBridgeProvider } from './WebViewBridgeProvider';
